module.exports = __webpack_public_path__ + "static/laptop@2x-05bffa191e72acde046f0f37a8529d1e.png";